import { postRequest, formDataRequest } from "../libs/AxiosService.util";

export async function serviceSalesInfoDetails(params) {
  return await postRequest("sales/target/employee/dashboard", params);
}
export async function serviceSalesStatusDetails(params) {
  return await postRequest("sales/target/employee/dashboard/target/status", params);
}
export async function serviceSalesGraphInfo(params) {
  return await postRequest("sales/target/employee/dashboard/target/achieved", params);
}
export async function serviceSalesTableData(params) {
  return await postRequest("sales/target/employee/dashboard/brand/wise", params);
}
export async function serviceSalesDoctorsDetails(params) {
  return await postRequest("sales/target/employee/dashboard/doctors", params);
}
export async function serviceSalesTargetDetails(params) {
  return await postRequest("sales/target/employee/my", params);
}
export async function serviceSalesCategoryDetail(params) {
  return await postRequest("sales/target/employee/dashboard/category/wise", params);
}
export async function serviceSalesIncentiveEarlyBird(params) {
  return await postRequest("sales/incentive", params);
}
export async function serviceSalesCustomEmployeeInfo(params) {
  return await postRequest("sales/target/employee/dashboard/team", params);
}
export async function serviceSalesCustomHQInfo(params) {
  return await postRequest("sales/target/employee/dashboard/hq", params);
}
export async function serviceSalesIncentiveProduct(params) {
  return await postRequest("sales/incentive/product/incentive", params);
}
export async function serviceSalesIncentiveProductTeam(params) {
  return await postRequest("sales/incentive/product/team/incentive", params);
}
export async function serviceSalesIncentiveValue(params) {
  return await postRequest("sales/incentive/rupee/incentive", params);
}
export async function serviceSalesIncentiveValueTeam(params) {
  return await postRequest("sales/incentive/rupee/team/incentive", params);
}
export async function serviceSalesIncentiveOverall(params) {
  return await postRequest("sales/incentive/overall/incentive", params);
}
export async function serviceGetSalesIncentives(params) {
  return await postRequest("sales/target/employee/dashboard/incentive", params);
}